import type { FC } from "react";

import { ScrollableSocialProofCards } from "@/ui/components/data-display/Card";
import { Container, Flex, Section } from "@/ui/components/layout";
import { Button } from "@/ui/components/primitives";
import { TextBody } from "@/ui/components/typography/TextBody";

import {
  SOCIAL_MEDIA_CALLOUT_DEFAULTS,
  SOCIAL_MEDIA_CALLOUT_SCROLL_FADE_CLASS,
  type TSocialMediaCalloutProps,
} from "./SocialMediaCallout.config";
import { SocialMediaCalloutFooter } from "./SocialMediaCalloutFooter";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";

const getFirstName = (name: string) => name.trim().split(/\s+/)[0] ?? "";

export const SocialMediaCallout: FC<TSocialMediaCalloutProps> = ({
  items,
  footerImages,
  memberCount,
  cta,
  title,
  body,
  footer,
  className,
  "data-component": component = SOCIAL_MEDIA_CALLOUT_DEFAULTS["data-component"],
  ...props
}) => {
  const firstName = getFirstName(items[0]?.author.name ?? "");

  return (
    <Section
      {...props}
      data-component={component}
      className={className}
    >
      <Flex direction="column" gap="2">
        <TextSubtitle size={1} isResponsive={false}>
          { title }
        </TextSubtitle>
        <TextBody size={2} isResponsive={false}>
          { body }
        </TextBody>
      </Flex>

      <Container data-component="SocialMediaCalloutCarousel" className="relative mt-4 mx-0">
        <ScrollableSocialProofCards items={items} />
        <Container
          aria-hidden="true"
          data-component="SocialMediaCalloutScrollFade"
          className={SOCIAL_MEDIA_CALLOUT_SCROLL_FADE_CLASS}
        />
        <Button
          asChild
          className="absolute -bottom-6 left-1/2 z-[2] w-max -translate-x-1/2"
          size="lg"
        >
          <a href={cta.href} target={cta.target} rel={cta.rel}>{ cta.label }</a>
        </Button>
      </Container>

      <SocialMediaCalloutFooter
        images={footerImages}
        label={footer({ firstName, memberCount })}
      />
    </Section>
  );
};

SocialMediaCallout.displayName = "SocialMediaCallout";
